import {
  call, put, select, takeLatest, delay,
} from 'redux-saga/effects';
import {
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE,
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST,
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS,
} from '../actions/constants/articulos.constants';
import { externalRequest } from '../../helpers/request.helper';
import getPayload from '../../helpers/jwt.helper';

const getAuthState = state => state.auth;
const getImagenesArticulosState = state => state.articulos;

function* obtenerImagenes() {
  try {
    yield delay(150);
    const authState = yield select(getAuthState);
    const imagenesArticulosState = yield select(getImagenesArticulosState);
    const { imagenes: imagenesFromState } = imagenesArticulosState;
    const { token } = authState;
    const jwtPayload = getPayload(token);
    const articulos = Object.keys(imagenesFromState).map((key) => imagenesFromState[key]).filter(articulo => articulo.loading !== false);

    if (jwtPayload && jwtPayload.pf_token) {

      const PF_API_URL = `${window.GIO_CONFIG.PF_API_URL}`;

      const { pf_token: pfToken } = jwtPayload;

      const requestItems = articulos.map(({ codigo_barra, codigo_EDI }) => ({
        upc: (codigo_barra == null) ? '' : codigo_barra,
        edi: (codigo_EDI == null) ? '' : codigo_EDI,
        size_code: 'NORM',
      }));

      const ediArticulos = [];
      const upcArticulos = [];

      articulos.forEach((articulo) => {
        const { codigo_barra, codigo_EDI } = articulo;
        if (codigo_barra !== null && codigo_barra !== undefined && codigo_barra.length > 2) {
          upcArticulos[codigo_barra] = articulo;
        }
        if (codigo_EDI !== null && codigo_EDI !== undefined && codigo_EDI.length > 2) {
          ediArticulos[codigo_EDI] = articulo;
        }
      });

      const jsonItems = JSON.stringify(requestItems);
      const firstArticulo = articulos[0];
      const { fabricante_id: fabricanteId } = firstArticulo;

      const obtenerImagenUrl = `${PF_API_URL}/external/images?manufacterCode=${fabricanteId}&items=${jsonItems}`;

      const params = {
        url: obtenerImagenUrl,
        method: 'GET',
        headers: {
          Authorization: pfToken,
        },
      };

      const responseData = yield call(externalRequest, params);
      const { datos: pfResponseData } = responseData;


      const imagenesHash = {};
      pfResponseData.forEach((articulo) => {
        const {
          codigo_articulo,
          ruta_publica_temporal: src,
          tipo_codigo_articulo: { codigo: tipoCodigo },
        } = articulo;
        let codigo = null;
        if (tipoCodigo === 'EDI') {
          const articulo = ediArticulos[codigo_articulo];
          if (articulo) {
            codigo = articulo.codigo;
          }
        } else {
          const articulo = upcArticulos[codigo_articulo];
          if (articulo) {
            codigo = articulo.codigo;
          }
        }
        imagenesHash[codigo] = {
          codigo,
          src,
        };
      });

      const imagenes = articulos.map(({ codigo }) => {
        const img = imagenesHash[codigo];
        if (img) {
          return img;
        }
        return {
          codigo,
          src: null,
        };
      });


      yield put({ type: IMAGENES_ARTICULOS_OBTENER_IMAGENES_SUCCESS, payload: { imagenes } });
    } else {
      const codigos = articulos.map(({ codigo }) => ({
        codigo,
      }));
      yield put({ type: IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE, payload: { codigos } });
    }
  } catch (ex) {
    yield put({ type: IMAGENES_ARTICULOS_OBTENER_IMAGENES_FAILURE, payload: { ex } });
  }
}

function* articulosSaga() {
  yield takeLatest(IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST, obtenerImagenes);
}

export default articulosSaga;
